export default "__VITE_ASSET__QpTLXicn__"